import { BookButton } from './book-button';
import { useWebScheduler } from './web-scheduler-provider';

export const WebSchedulerWidget = () => {
    const { webSchedulerScriptLoadedSuccessfully } = useWebScheduler();
    const handleClick = () => {
        window.STWidgetManager('ws-open');
    };

    return webSchedulerScriptLoadedSuccessfully && <BookButton onClick={handleClick} />;
};
